<template>
  <SfMessageOuterContainer>
    <SfMessageContainer :read="true">
      <template #body>
        <div
          v-dompurify-html="renderedText"
          class="tw-text-sm suggested-talking-point__description"
        />
      </template>
      <template #footer>
        <div class="tw-pt-2">
          <SfButtonDs
            size="sm"
            variant="secondary"
            data-heap="add-to-agenda"
            @click="addToAgenda"
          >
            <span
              class="
                tw-flex tw-flex-row tw-items-center tw-align-baseline tw-gap-2
              "
            >
              <i class="fa fa-arrow-left" />
              {{ copy.addToAgendaLabel }}
            </span>
          </SfButtonDs>
        </div>
      </template>
    </SfMessageContainer>
  </SfMessageOuterContainer>
</template>

<script setup lang="ts">
import { computed, inject } from 'vue'

import type { PreparePageData } from '@app/application/client_meetings/types'
import { marked } from 'marked'
import useOpenRemarkModal from '@app/shared/vue/composables/use-open-remark-modal'
import { useTalkingPointTag } from '@app/application/client_meetings/composables/use-talking-point-tag'

import { SfButtonDs } from '@silverfin/ui-components'
import SfMessageContainer from '@app/shared/vue/components/sf-message/sf-message-container.vue'
import SfMessageOuterContainer from '@app/shared/vue/components/sf-message/sf-message-outer-container.vue'

import useI18n from '@app/shared/vue/composables/use-I18n'

interface Props {
  text: string
}

const I18n = useI18n()
const copy = {
  addToAgendaLabel: I18n.t('client_meetings.prepare.suggestion.add_to_agenda'),
}

const props = withDefaults(defineProps<Props>(), {
  text: '',
})

const renderedText = computed(() => marked(props.text))

function addToAgenda() {
  const callbackPayload = {
    suggestionText: props.text,
  }

  openNewRemarkModal({ text: props.text }, callbackPayload)
}

const pageData = inject('pageData') as PreparePageData

const { talkingPointTagIds: selectedTagIds } = useTalkingPointTag()

const openNewRemarkModal = useOpenRemarkModal({
  ownerType: 'ClientMeeting',
  ownerId: pageData.clientMeetingId,
  remarkText: true,
  hidePeriodSelector: true,
  selectedTagIds: selectedTagIds,
  modalSize: 'l',
  isClientMeetingRemark: true,
})
</script>

<style lang="scss">
.suggested-talking-point {
  &__description {
    blockquote {
      margin-bottom: 16px;
    }

    ul,
    ol {
      padding-left: 16px;
      margin-bottom: 16px;
    }

    ul {
      list-style-type: disc;
    }

    ol {
      list-style-type: decimal;
    }
  }
}
</style>
